var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useEffect, useMemo } from 'react';
import { nanoid } from 'nanoid';
import { ExpansionContext } from './expansion-context';
import { StyledAccordion } from './styles';
export default function ExpansionItem(_a) {
    var children = _a.children, disabled = _a.disabled, _b = _a.header, header = _b === void 0 ? false : _b, props = __rest(_a, ["children", "disabled", "header"]);
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    var _d = useContext(ExpansionContext), contextExpanded = _d.contextExpanded, setContextExpanded = _d.setContextExpanded, singleExpand = _d.singleExpand;
    var id = useMemo(function () { return nanoid(); }, []);
    useEffect(function () {
        if (contextExpanded === id) {
            setExpanded(true);
        }
        else {
            setExpanded(false);
        }
    }, [contextExpanded]);
    var handleChange = function () {
        if (!singleExpand) {
            setExpanded(function (prev) { return !prev; });
        }
        if (singleExpand && contextExpanded === id) {
            setContextExpanded('');
        }
        if (singleExpand && contextExpanded !== id) {
            setContextExpanded(id);
        }
    };
    return (_jsxs(StyledAccordion, __assign({ className: header ? 'AccordionHeader' : '', disabled: disabled || header, expanded: expanded, onChange: handleChange }, props, { children: [children, ' '] })));
}
